import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { RequestMethod } from "../../types/RequestOptions";
import { appendParamsToURI, getAbsoluteURIIfRelative } from "./url";

/*
	To be used by only backend request
*/
function prepareFetchPayload(uri, options) {
  var method = options.method || RequestMethod.GET;
  var _options$headers = options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers;
  var _options$payload = options.payload,
      payload = _options$payload === void 0 ? {} : _options$payload;
  uri = getAbsoluteURIIfRelative(uri);

  switch (method.toUpperCase()) {
    case RequestMethod.GET:
      uri = appendParamsToURI(uri, payload);
      break;

    case RequestMethod.POST:
    case RequestMethod.DELETE:
    case RequestMethod.PUT:
      headers = _objectSpread(_objectSpread({}, headers), {}, {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      });
      break;

    default:
      throw new Error("Invalid post-method passed, only GET and POST supported");
  }

  return {
    uri: uri,
    method: method,
    headers: headers
  };
}

export function backendRequest(_uri) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = options.payload;

  var _prepareFetchPayload = prepareFetchPayload(_uri, options),
      uri = _prepareFetchPayload.uri,
      method = _prepareFetchPayload.method,
      headers = _prepareFetchPayload.headers;

  return fetch(uri, {
    headers: headers,
    method: method,
    credentials: options.credentials || "include",
    mode: "cors",
    body: method !== RequestMethod.GET ? JSON.stringify(payload) : null
  }).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestResponse) {
      var _yield$requestRespons, message;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(requestResponse.status > 500)) {
                _context.next = 2;
                break;
              }

              throw new Error("Server error ".concat(requestResponse.status, " at ").concat(uri));

            case 2:
              if (!(requestResponse.status === 400)) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return requestResponse.json();

            case 5:
              _yield$requestRespons = _context.sent;
              message = _yield$requestRespons.message;
              throw new Error(message);

            case 8:
              return _context.abrupt("return", requestResponse.json());

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}
export function cleanHeaders(headers) {
  if (headers) {
    delete headers["content-length"];
    delete headers["host"];
    delete headers["origin"];
  }
}